import { Component, OnInit } from '@angular/core';
import { Church } from '../church';
import { StarService } from '../services/star.service';

@Component({
  selector: 'app-favorites',
  templateUrl: './favorites.component.html',
  styleUrls: ['./favorites.component.css']
})
export class FavoritesComponent implements OnInit {

  churches: Map<string, Church> = new Map();

  constructor(private starService: StarService) { }

  ngOnInit(): void {
    this.churches = this.starService.getStarred();
  }
}
